
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * FiltrationOfNullable enum
 */
class FiltrationOfNullable {
  /**
   * Initialize enum with a given value
   * @param {FiltrationOfNullable|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof FiltrationOfNullable) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!FiltrationOfNullable}
   * @param {!FiltrationOfNullable} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FiltrationOfNullable)) {
      throw new TypeError('Instance of FiltrationOfNullable is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!FiltrationOfNullable}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!FiltrationOfNullable}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === FiltrationOfNullable.IS_NULL_SUITABLE.value) {
      return 'IS_NULL_SUITABLE'
    }
    if (this.value === FiltrationOfNullable.IS_NON_NULL_SUITABLE.value) {
      return 'IS_NON_NULL_SUITABLE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!FiltrationOfNullable}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!FiltrationOfNullable}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!FiltrationOfNullable} Created enum
   */
  static fromObject (other) {
    return new FiltrationOfNullable(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
FiltrationOfNullable.IS_NULL_SUITABLE = new FiltrationOfNullable(0 + 0)
// noinspection PointlessArithmeticExpressionJS
FiltrationOfNullable.IS_NON_NULL_SUITABLE = new FiltrationOfNullable(0 + 1)

export { FiltrationOfNullable };

/**
 * Fast Binary Encoding FiltrationOfNullable field model
 */
class FieldModelFiltrationOfNullable extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelFiltrationOfNullable}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelFiltrationOfNullable}
   * @param {FiltrationOfNullable=} defaults Default value, defaults is new FiltrationOfNullable()
   * @returns {!FiltrationOfNullable} Result value
   */
  get (defaults = new FiltrationOfNullable()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new FiltrationOfNullable(this.readUInt8(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelFiltrationOfNullable}
   * @param {!FiltrationOfNullable} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeUInt8(this.fbeOffset, value.value)
  }
}

export { FieldModelFiltrationOfNullable };
